const beige = "#e6e3dd";
const darkBeige = "#dcd8c6";
const blue = "#007d9e";
const lightGrey = "#cccccc";
const mediumGrey = "#666666";
const darkGrey = "#333333";
const white = "#ffffff";

const colours = {
  primary: blue,
  secondary: darkBeige,
  white: white,
  background: beige,
  lightGrey: lightGrey,
  mediumGrey: mediumGrey,
  darkGrey: darkGrey
};

const layout = {
  maxWidth: "1070px"
};

export const theme = {
  colours,
  layout
};
